import { IAidasProject } from 'app/shared/model/ainnotateservice/aidas-project.model';

export interface IAidasObject {
  id?: number;
  name?: string;
  description?: string | null;
  numberOfUploadReqd?: number;
  aidasProject?: IAidasProject;
}

export const defaultValue: Readonly<IAidasObject> = {};
